module.exports = {"pi":{"clientId":"SDXgs4VjABgmXXA0iLjRyFeMqnYyVwHU"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 828
// module chunks = 0